import Excel from "exceljs";
import { saveAs } from "file-saver";

/**
 * Creates and downloads an Excel file for the Weekly Merchant Sales Report
 * @param {Array} data - Array of merchant sales data
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 */
export const createWeeklyMerchantSalesExcelFile = async (data, startDate, endDate) => {
  const workbook = new Excel.Workbook();
  const sheet = workbook.addWorksheet("Weekly Merchant Sales");

  // Define Columns
  sheet.columns = [
    { header: "Account", key: "account", width: 15 },
    { header: "Merchant Name", key: "name", width: 30 },
    { header: "District", key: "district", width: 20 },
    { header: "Location", key: "city", width: 20 },
    { header: "Group", key: "group", width: 15 },
    { header: "Sales", key: "salesTotal", width: 15 },
  ];

  // Style Header
  sheet.getRow(1).font = { bold: true };

  // Add Data Rows
  data.forEach((item) => {
    sheet.addRow({
      account: item.account,
      name: item.name,
      district: item.district,
      city: item.city,
      group: item.group,
      salesTotal: item.salesTotal || 0,
    });
  });

  // Generate & Save
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `Weekly_Merchant_Sales_Report_${startDate}_${endDate}.xlsx`
  );
};
